import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './KnowledgeChecker.module.css';

type AnswerItem = {
	fields: {
		AnswerContent: Field<string>;
		CorrectAnswer: Field<boolean>;
		Explanation: Field<string>;
	};
};

type QuestionItem = {
	fields: {
		QuestionContent: Field<string>;
		Answers: AnswerItem[];
	};
};

export type KnowledgeCheckerProps = ComponentProps & {
	fields: {
		Questions: QuestionItem[];
		Title: Field<string>;
		Description: Field<string>;
		WrapupText: Field<string>;
		CorrectAnswerImage: ImageField;
		IncorrectAnswerImage: ImageField;
	};
};

export default function KnowledgeChecker(props: KnowledgeCheckerProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<div className={`maxWidth pad`} data-display-pdf-download>
			<FieldEditFrame
				itemId={props.rendering?.dataSource ?? undefined}
				header="Edit Knowledge Checker"
			>
				<EditorHelp text={'Click here to change the appearance of the Knowledge Checker'} />
				<div>
					<div>
						<Text tag="h3" field={props.fields?.Title} className={styles.knowledgeCheckerTitle} />
						<Text tag="p" field={props.fields?.Description} />
					</div>
					<div>
						{props.fields?.Questions.map((question, index) => (
							<div key={index} className={styles.questionContainer}>
								<Text tag="h3" className={styles.questionNumber} field={{ value: `Question ${index + 1}` }} />
								<RichText tag="div" field={question.fields.QuestionContent ?? { value: 'Question content, where are you?' }} />
								<div>
									{question.fields.Answers.map((answer, answerIndex) => {
										const answerImageSrc = answer.fields.CorrectAnswer?.value ? props.fields?.CorrectAnswerImage.value?.src : props.fields?.IncorrectAnswerImage.value?.src;
										const dynamicImage = {"--answer-image": `url(${answerImageSrc})`};

										return (
											<details key={answerIndex} className={styles.answerContainer}>
											<summary className={styles.answerSummary}>
												<RichText tag="div" field={answer.fields.AnswerContent} className={styles.answerContent} />
											</summary>
											<Text tag="p" field={answer.fields.Explanation} className={styles.answerExplanation} style={dynamicImage} />
										</details>
									)})}
								</div>
							</div>
						))}
					</div>
					<div className={styles.wrapupContainer}>
						<Text tag="section" field={props.fields?.WrapupText} />
					</div>
				</div>
			</FieldEditFrame>
		</div>
	);
}
